import { Link, useLocation } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { motion } from "framer-motion";

export default function Nav() {
  const { count } = useCart();
  const { pathname } = useLocation();
  const light = pathname === "/";

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 mix-blend-difference"
      data-testid="main-nav"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between text-white">
        <Link to="/" data-testid="nav-logo" className="font-display font-black text-xl tracking-tight uppercase">
          Merch<span className="text-[#0044ff]">·</span>Studio
        </Link>
        <nav className="flex items-center gap-6 md:gap-10 text-xs font-bold uppercase tracking-[0.15em]">
          <Link to="/#catalogue" data-testid="nav-catalogue" className="hidden sm:block hover:opacity-60 transition-opacity">
            Catalogue
          </Link>
          <Link to="/#process" data-testid="nav-process" className="hidden sm:block hover:opacity-60 transition-opacity">
            Méthode
          </Link>
          <Link
            to="/devis"
            data-testid="nav-devis"
            className="flex items-center gap-2 border border-white/60 px-4 py-2 hover:bg-white hover:text-black transition-colors"
          >
            Devis
            {count > 0 && (
              <span className="inline-flex items-center justify-center min-w-5 h-5 px-1 bg-[#0044ff] text-white text-[10px] font-mono rounded-full">
                {count}
              </span>
            )}
          </Link>
        </nav>
      </div>
    </motion.header>
  );
}
